// Importación de funcionalidades
// import { defineAsyncComponent } from 'vue';
import {createRouter, createWebHistory} from 'vue-router';

// Importación de Componentes
import PagPrincipal from './components/pages/PagPrincipal.vue';
import NotFound from './components/pages/NotFound.vue';
const SobreNosotros = () => import('./components/pages/SobreNosotros.vue');
const ElProceso = () => import('./components/pages/ElProceso.vue');
const NuestroMenu = () => import('./components/pages/NuestroMenu.vue');
const LaGaleria = () => import('./components/pages/LaGaleria.vue');
const Contacto = () => import('./components/pages/Contacto.vue');

// Creación de Router
const router = createRouter({
  routes: [
    {path: '/', redirect: '/inicio'},
    {path: '/inicio', component: PagPrincipal},
    {path: '/nosotros', component: SobreNosotros},
    {path: '/proceso', component: ElProceso},
    {path: '/menu', component: NuestroMenu},
    {path: '/galeria', component: LaGaleria},
    {path: '/contacto', component: Contacto},
    {path: '/:notFound(.*)', component: NotFound}
  ],
  history: createWebHistory()
});

//Export
export default router;